import { NgModule } from '@angular/core';
import { SetFocusOnDirective } from 'common/on-event-focus/ng2-set-focus.directive';

@NgModule({
  declarations: [
    SetFocusOnDirective
  ],
  exports: [
    SetFocusOnDirective
  ]
})
export class Ng2SetFocusModule {}
